import { Dispatch, SetStateAction, useEffect, useLayoutEffect, useRef, useState } from 'react'
import { useWallet } from '@web/walter-lib/stream'
import { useSearchParams } from 'react-router-dom'
import { CardsViews } from './types'
import { useCards, useProducts } from '~api'
import { useMenuStore } from '~store/menu'
import { QueryParams } from '~constants/routes'

export const useInitial = (setView: Dispatch<SetStateAction<CardsViews>>, view: CardsViews) => {
    const [isLoading, setIsLoading] = useState(true)

    const { isLoading: isProductsLoading } = useProducts()
    const { isLoading: isCardsLoading, data: cards, error } = useCards()

    const hasInit = useRef(false)
    useWallet()

    useEffect(() => {
        if (isProductsLoading || isCardsLoading || hasInit.current) {
            return
        }

        hasInit.current = true
        setIsLoading(false)

        if (cards && cards.cards.length > 0) {
            setView(CardsViews.Cards)
            return
        }

        setView(CardsViews.NoCards)
    }, [cards, isProductsLoading, isCardsLoading, setView])

    const { setData } = useMenuStore()

    useEffect(() => {
        let onCardClick = () => {
            return
        }

        if ((view === CardsViews.NewCards || view === CardsViews.NewCard) && cards && cards.cards.length > 0) {
            onCardClick = () => {
                setView(CardsViews.Cards)
            }
        }

        setData({
            onCardClick,
        })
    }, [cards, setData, setView, view])

    return { isLoading, isError: !!error }
}

export const useOpenNoCardsTopUp = (setOpenNoCardsTopup: (args: { isOpen: boolean; currency: string }) => void) => {
    const { data: cards, isLoading, error } = useCards()
    const [isInitialOpen, setInitialOpen] = useState(false)
    const [searchParams, setSearchParams] = useSearchParams()
    const action = searchParams.get(QueryParams.action) || ''
    const currency = searchParams.get(QueryParams.currency) || ''

    useLayoutEffect(() => {
        if (action !== 'topup' || isInitialOpen || isLoading || !!error) {
            return
        }

        const isCardExist = cards?.cards?.some(
            card =>
                card?.status === 'ACTIVE' && (!currency || card?.currency?.toUpperCase() === currency?.toUpperCase())
        )

        if (!isCardExist) {
            setOpenNoCardsTopup({ isOpen: true, currency })
            setInitialOpen(true)
            setSearchParams(
                prev => {
                    prev.delete(QueryParams.action)
                    prev.delete(QueryParams.currency)
                    return prev
                },
                { replace: true }
            )
        }
    }, [action, cards?.cards, currency, error, isInitialOpen, isLoading, setOpenNoCardsTopup, setSearchParams])
}
